import { CartItem } from "../types/Generic";
export enum UiVersion {
  DEMO,
  DEFAULT,
  STANDARD,
  AUTHENTICATION,
  TABLE_NOT_FOUND,
}
export enum ItemTypes {
  Drink,
  Food,
  Combo,
}

export enum ItemClickAction {
  Add,
  Remove,
}

export const EndPoints = {
  ALL: {
    ITEMS: "/client",
  },
  DRINK: {
    CATEGORIES: "/drink_category",
    CATEGORY: "/drink_category",
    DRINKS: "/drink/drinks",
    DRINK: "/drink/",
    USER_SETTINGS: "/drink/",
  },
  FOOD: {
    CATEGORY: "/food_category",
  },
  COMBO: {
    CATEGORY: "/combos",
  },
  ORDER: {
    SUBMIT: "/order/",
    GET_ALL: (clientId: string, mtId: string) =>
      `/client/orders/${clientId}/${mtId}`,
    TABLE_SESSION_CURRENT: (
      clientId: string,
      tableNumber: string,
      segment: string,
      tableId?: string
    ) =>
      `/order/table-session/current?clientId=${encodeURIComponent(
        clientId
      )}&tableNumber=${encodeURIComponent(
        tableNumber
      )}&segment=${encodeURIComponent(segment)}${
        tableId ? `&tableId=${encodeURIComponent(tableId)}` : ""
      }`,
  },
  PAYMENT: {
    TABLE_SESSION_START: (sessionId: string) =>
      `/payment/table-session/${sessionId}/start`,
    TABLE_SESSION_CHECKOUT: (sessionId: string) =>
      `/payment/table-session/${sessionId}/checkout`,
    TABLE_SESSION_VERIFY: (sessionId: string) =>
      `/payment/table-session/${sessionId}/verify`,
  },
  TABLE: {
    RESOLVE: (username: string, segment: string, table: string) =>
      `/table/resolve?username=${encodeURIComponent(
        username
      )}&segment=${encodeURIComponent(segment)}&table=${encodeURIComponent(
        table
      )}`,
  },
  ANALYTICS: {
    CLIENT_ACTIVITY: "/analytics/client-activity",
  },
  WAITLIST: {
    SUBMIT: "/wait-list",
  },
  DEMO: {
    CLONE: "/demo/clone",
  },
  REGISTER: {
    SUBMIT: "/client/register",
  },
  FEEDBACK: {
    SUBMIT: (clientId: string) => `/client/${clientId}/feedback`,
  },
};
export const getItemName = (itemType: number) =>
  itemType === ItemTypes.Food ? "Food" : "Drink";

export const getItemsInCart = (cartItems: CartItem[]) => {
  if (cartItems.length) {
    return cartItems
      .map((item) => item.count)
      .reduce((prev, current) => prev + current);
  }
  return 0;
};
export const calculateCartItemPrice = (
  currencyPrefix: string,
  price: number,
  itemCount: number
): string => {
  let itemPrice = `${currencyPrefix}${price.toLocaleString()}`;
  if (itemCount > 1) {
    itemPrice = itemPrice.concat(` x${itemCount}`);
  }

  return itemPrice;
};

export const getURLParams = (searchParams: string[]) => {
  const searchString = window.location.search;
  const urlParams = new URLSearchParams(searchString);
  const retrievedParams: { [key: string]: string } = {};

  searchParams.forEach((param) => {
    if (urlParams.has(param)) {
      retrievedParams[param] = urlParams.get(param) || "";
    }
  });

  return retrievedParams;
};
